var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "mb-4", attrs: { title: "Order List" } },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c(
                "div",
                [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "perPage" } },
                    [_vm._v("Per page")]
                  ),
                  _c("b-form-select", {
                    staticClass: "w-auto",
                    attrs: { id: "perPage", options: _vm.perPageOptions },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("b-table", {
            attrs: {
              items: _vm.orders,
              fields: _vm.fields,
              responsive: "sm",
              bordered: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(orderStatus)",
                fn: function (data) {
                  return [
                    _c("b-form-select", {
                      staticClass: "w-100",
                      attrs: { options: _vm.orderStatusOptions },
                      on: {
                        change: function ($event) {
                          return _vm.updateOrderStatus(data.item)
                        },
                      },
                      model: {
                        value: data.item.orderStatus,
                        callback: function ($$v) {
                          _vm.$set(data.item, "orderStatus", $$v)
                        },
                        expression: "data.item.orderStatus",
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(orderedAt)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(data.item.orderedAt)) + " "
                    ),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (data) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "success", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.viewOrder(data.item)
                          },
                        },
                      },
                      [_vm._v(" View Order ")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-2",
                        attrs: { variant: "success", size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.convertInvoice(data.item)
                          },
                        },
                      },
                      [_vm._v(" Create Invoice ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mt-3",
            },
            [
              _c("div", [
                _vm._v(
                  " Showing " +
                    _vm._s(_vm.firstItem) +
                    " to " +
                    _vm._s(_vm.lastItem) +
                    " of " +
                    _vm._s(_vm.totalEntries) +
                    " entries "
                ),
              ]),
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalEntries,
                  "per-page": _vm.perPage,
                  align: "right",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "orderModal",
            title: "Order Details",
            "hide-footer": "",
          },
        },
        [
          _vm.selectedOrder
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    _vm._l(_vm.selectedOrder.lines, function (item) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: item.cartLineId,
                          staticClass: "d-flex align-items-center",
                        },
                        [
                          _c("img", {
                            staticClass: "order-img",
                            attrs: {
                              src: item.product.imageUrl,
                              alt: "Product Image",
                            },
                          }),
                          _c("div", { staticClass: "ml-3" }, [
                            _c("h5", [
                              _vm._v(_vm._s(item.product.productName)),
                            ]),
                            _c("p", [
                              _vm._v("Price: Rs" + _vm._s(item.product.price)),
                            ]),
                            _c("p", [
                              _vm._v("Quantity: " + _vm._s(item.quantity)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                  _c("div", { staticClass: "mt-3" }, [
                    _c("h5", [_vm._v("Shipping Address")]),
                    _vm.selectedOrder.shippingAddress
                      ? _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedOrder.shippingAddress.line1)
                          ),
                          _c("br"),
                          _vm.selectedOrder.shippingAddress.line2
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedOrder.shippingAddress.line2
                                  )
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm.selectedOrder.shippingAddress.line3
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedOrder.shippingAddress.line3
                                  )
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedOrder.shippingAddress.city) +
                              " "
                          ),
                        ])
                      : _c("p", [_vm._v("No shipping address available")]),
                  ]),
                ],
                1
              )
            : _c("div", [_c("p", [_vm._v("No order details available.")])]),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { variant: "secondary" },
              on: {
                click: function ($event) {
                  return _vm.$bvModal.hide("orderModal")
                },
              },
            },
            [_vm._v(" Close ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }